<div class="row">
  <div class="col-md-8 mx-auto text-center">
    <h1>CRIAR NOVA CONTA</h1>
  </div>
</div>

<div class="card o-hidden mt-5" [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
  <div class="row">
    <div class="col-md-8 mx-auto">
      <div class="p-4">
        <form [formGroup]="form" (validSubmit)="signUp($event)">
          <div class="row" *ngIf="showError">
            <ngb-alert class="alert-card col-md-12" [type]="'danger'" (close)="closeAlert()"
              *ngIf="statusUser === 'REGISTERED_USER'; else showMessageError">
              <span>O e-mail <strong>{{form.get('email').value}}</strong> já cadastrado clique <a
                  [routerLink]="['/forgot-password']">aqui</a> recuperar sua senha.</span>
            </ngb-alert>

            <ng-template #showMessageError>
              <ngb-alert class="alert-card col-md-12" [type]="'danger'" (close)="closeAlert()">
                <span>{{messageError}}</span>
              </ngb-alert>
            </ng-template>


          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input matInput placeholder="E-MAIL" formControlName="email">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 mx-auto">
              <btn-loading *ngIf="!showSuccess"
                btnClass="btn-primary btn-lg btn-rounded btn-block mt-4" [loadingText]="loadingText"
                [loading]="loading$ | async">
                Criar Conta
              </btn-loading>
            </div>
          </div>
          <ngb-alert *ngIf="showSuccess" [dismissible]="false" class="alert-card col-md-12" [type]="'success'">
            <span>Em poucos minutos você receberá em seu e-mail um link para criar seu cadastro.</span>
          </ngb-alert>
        </form>
      </div>
    </div>
  </div>
</div>